import { all, AllEffect, call, ForkEffect, put, StrictEffect, takeEvery } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  getLoginHistoryError,
  getLoginHistorySuccess,
  LoginHistoryActionType,
} from '../actions/loginHistoryActions';
import bffApiService from '@/shared/bffApiService';

export function* getLoginHistorySaga(): Generator<StrictEffect, void, AxiosResponse<any>> {
  try {
    const loginHistoryResponse = yield call(bffApiService.getLoginHistory);

    yield put(getLoginHistorySuccess(loginHistoryResponse.data.data));
  } catch (error) {
    yield put(getLoginHistoryError());
  }
}

export function* watchLoginHistory(): Generator<AllEffect<ForkEffect<never>>, void> {
  yield all([takeEvery(LoginHistoryActionType.GetLoginHistory, getLoginHistorySaga)]);
}
